import axios from 'axios'
import { EVENT_SUPPLIER, USER_TOKEN } from "./CONSTANTS";

export const getEventSuppliers = () => {
  console.info("eventSupplierServices > getEventSuppliers...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT_SUPPLIER(),{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addEventSuppliers = (model) => {
  console.info("eventSupplierServices > addEventSuppliers...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT_SUPPLIER(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const updateEventSuppliers = (model) => {
  console.info("updateSupplierServices > updateEventSuppliers...");
  return new Promise((resolve, reject) => {
      axios
      .put(EVENT_SUPPLIER(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const deleteEventSuppliers = (uniqueKey) => {
  console.info("eventSupplierServices > deleteEventSuppliers...");
  return new Promise((resolve, reject) => {
      axios
      .delete(EVENT_SUPPLIER()+'/'+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};